<template>
    <div>
        <vue-good-table mode="remote" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            :isLoading.sync="table.isLoading" :pagination-options="{
          nextLabel: 'Berikutnya', prevLabel: 'Sebelumnya', rowsPerPageLabel: 'Per halaman', ofLabel: 'dari', pageLabel: 'Halaman', allLabel: 'Semua',
          enabled: false
        }" :columns="table.columns" :rows="table.rows">
            <div slot="emptystate" class="tw-py-8 tw-text-center tw-text-[14px] tw-text-muted">Belum ada data.</div>
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    <router-link :to="'/incoming/detail?id=' + props.row.id">
                        <a class="wl-btn wl-btn-primary wl-btn-sm margin5">Detail</a>
                    </router-link>
                    <a v-on:click="deleteIncoming(props.row.id)" class="wl-btn wl-btn-danger wl-btn-sm margin5">
                        Hapus
                    </a>
                </span>
                <span v-else-if="props.column.field == 'text'">
                    {{ cutString(props.row.text) }}
                    <div v-if="props.row.file">
                        <br>
                        <div class="wl-card">
                            <div class="wl-card-body">
                                <center>
                                    <b>Document</b>
                                    <br>
                                    <a :href="props.row.file" target="_blank"> Open File </a>
                                </center>
                            </div>
                        </div>
                    </div>
                </span>
                <span v-else-if="props.column.field == 'created_at'">
                    {{ convertDateToLocal(props.row.created_at) }}
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
        <div class="tw-flex tw-items-center tw-justify-between tw-mt-2">
            <div class="tw-flex tw-items-center">
                <label class="tw-mr-2 tw-mb-0">Per halaman</label>
                <select class="wl-select wl-input-sm tw-w-auto" v-model.number="table.serverParams.limit" @change="onLimitChange">
                    <option :value="10">10</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                </select>
            </div>
            <div class="tw-flex tw-items-center">
                <span class="tw-text-muted tw-text-sm tw-mr-4" v-if="table.rows && table.rows.length">Showing {{ table.rows.length }} items</span>
                <div class="tw-inline-flex tw-flex-wrap tw-gap-2" role="group" aria-label="Pagination controls">
                    <button
                        class="wl-btn wl-btn-ghost wl-btn-sm"
                        :disabled="cursorStack.length === 0 || table.isLoading"
                        @click="goPrevPage"
                        title="Go to previous page"
                        aria-label="Halaman sebelumnya">
                        <i class="fas fa-chevron-left" aria-hidden="true"></i>
                        <span class="tw-hidden sm:tw-inline"> Sebelumnya</span>
                    </button>
                    <button
                        class="wl-btn wl-btn-ghost wl-btn-sm"
                        :disabled="!hasMore || table.isLoading"
                        @click="goNextPage"
                        title="Go to next page"
                        aria-label="Halaman berikutnya">
                        <span class="tw-hidden sm:tw-inline">Berikutnya </span>
                        <i class="fas fa-chevron-right" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data() {
            return {
                table: {
                    isLoading: true,
                    columns: [{
                            label: "Pengirim",
                            field: "number",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "15%",
                        },
                        {
                            label: "Text",
                            field: "text",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "40%",
                        },
                        {
                            label: "Diterima pada",
                            field: "created_at",
                            filterOptions: {
                                enabled: false,
                            },
                            sortable: false,
                            width: "25%",
                        },
                        {
                            label: "Aksi",
                            field: "action",
                            sortable: false,
                            width: "20%",
                        },
                    ],
                    rows: [],
                    serverParams: {
                        columnFilters: {},
                        sort: [{
                            field: "",
                            type: "",
                        }, ],
                        limit: 10,
                        last_id: null,
                    },
                },
                hasMore: false,
                cursorStack: [],
            };
        },
        mounted() {
            this.fn = () => {
                this.loadItems();
            }
            this.$root.$on("refresh_table", this.fn);
            this.loadItems();
        },
        beforeDestroy() {
            this.$root.$off("refresh_table", this.fn);
        },
        methods: {
            cutString(string) {
                if(string == null || string == "") return ""

                if (string.length > 40) {
                    string = string.slice(0, 40) + "..."
                }

                return string
            },
            convertDateToLocal(date) {
                return moment.utc(date).local().format("YYYY-MM-DD HH:mm:ss")
            },
            async deleteIncoming(id) {
                try {
                    let response = await this.$store.dispatch("incoming_delete", {
                        id: id
                    });
                    this.loadItems();
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error("Server error");
                }
            },
            updateParams(newProps) {
                this.table.serverParams = Object.assign({},
                    this.table.serverParams,
                    newProps
                );
            },
            onLimitChange() {
                this.updateParams({
                    limit: this.table.serverParams.limit,
                    last_id: null
                });
                this.cursorStack = [];
                this.loadItems();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.table.columns[params.columnIndex].field,
                    }, ],
                    last_id: null,
                });
                this.cursorStack = [];
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(Object.assign({}, params, { last_id: null }));
                this.cursorStack = [];
                this.loadItems();
            },
            goPrevPage() {
                if (this.cursorStack.length > 0) {
                    const prevCursor = this.cursorStack.pop();
                    this.updateParams({ last_id: prevCursor });
                    this.loadItems();
                }
            },
            goNextPage() {
                if (this.hasMore) {
                    this.cursorStack.push(this.table.serverParams.last_id);
                    const rows = this.table.rows || [];
                    const nextCursor = rows.length > 0 ? rows[rows.length - 1].id : null;
                    this.updateParams({ last_id: nextCursor });
                    this.loadItems();
                }
            },
            async loadItems() {
                this.table.isLoading = true
                try {
                    let response = await this.getFromServer(this.table.serverParams);
                    let incoming = response.data.data.incomings;
                    // for (let i = 0; i < outgoing.length; i++) {
                    //     if(outgoing[i].message_type == "button"){
                    //         outgoing[i].parsedButton = await JSON.parse(outgoing[i].data)
                    //         outgoing[i].footer = outgoing[i].parsedButton[0].footer
                    //     }
                    // }
                    this.table.rows = incoming
                    this.hasMore = Array.isArray(incoming) && incoming.length === this.table.serverParams.limit
                } catch (err) {
                    console.log(err)
                    this.$toast.error("Too many request");
                }
                this.table.isLoading = false
            },
            async getFromServer(param) {
                const payload = {
                    limit: param.limit,
                };
                if (param.last_id) {
                    payload.last_id = param.last_id;
                }
                if (param.columnFilters) {
                    payload.columnFilters = param.columnFilters;
                }
                if (param.sort && param.sort.length && param.sort[0].field) {
                    payload.sort = param.sort;
                }
                return await this.$store.dispatch("incoming_list", payload);
            },
        },
    };
</script>

<style scoped>
    .margin5 {
        margin: 5px;
    }
</style>